(function () {
  var VISIBLE_THUMBS = 4;

  function build(column) {
    if (column.dataset.amirioThumbs === 'true') return;

    var slides = column.querySelectorAll('.product-media-container');
    if (slides.length < 2) return;

    var images = [];
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && slides[i].offsetHeight > 0) {
        images.push({ slide: slides[i], src: img.currentSrc || img.src, alt: img.alt || '' });
      }
    }
    if (images.length < 2) return;

    column.dataset.amirioThumbs = 'true';

    var rail = document.createElement('div');
    rail.className = 'amirio-thumbs';

    var inner = document.createElement('div');
    inner.className = 'amirio-thumbs__inner';
    rail.appendChild(inner);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'amirio-thumbs__arrow amirio-thumbs__arrow--prev';
    prev.setAttribute('aria-label', 'Previous images');
    prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m15 20-7.5-7.5L15 5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    inner.appendChild(prev);

    var viewport = document.createElement('div');
    viewport.className = 'amirio-thumbs__viewport';
    inner.appendChild(viewport);

    var track = document.createElement('div');
    track.className = 'amirio-thumbs__track';
    viewport.appendChild(track);

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'amirio-thumbs__arrow amirio-thumbs__arrow--next';
    next.setAttribute('aria-label', 'More images');
    next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m9 5 7.5 7.5L9 20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    inner.appendChild(next);

    images.forEach(function (item, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'amirio-thumbs__item';
      button.setAttribute('aria-label', 'Show image ' + (index + 1));

      var thumb = new Image();
      thumb.src = item.src.indexOf('/cdn/') > -1 ? item.src.replace(/([?&])width=\d+/, '$1width=128') : item.src;
      thumb.alt = item.alt;
      thumb.loading = 'lazy';
      button.appendChild(thumb);

      button.addEventListener('click', function () {
        item.slide.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });

      track.appendChild(button);
    });

    column.insertBefore(rail, column.firstChild);

    var buttons = track.querySelectorAll('.amirio-thumbs__item');

    prev.addEventListener('click', function () {
      images[Math.max(0, activeIndex() - 1)].slide.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      images[Math.min(images.length - 1, activeIndex() + 1)].slide.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    function activeIndex() {
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function markActive() {
      var mid = column.scrollTop + column.clientHeight / 3;
      var active = 0;
      for (var i = 0; i < images.length; i++) {
        if (images[i].slide.offsetTop <= mid) active = i;
      }
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].classList.toggle('is-active', j === active);
      }

      prev.disabled = active === 0;
      next.disabled = active === images.length - 1;

      var thumbHeight = buttons[0].offsetHeight + 4;
      var maxOffset = Math.max(0, buttons.length - VISIBLE_THUMBS) * thumbHeight;
      var offset = Math.min(Math.max(0, active - (VISIBLE_THUMBS - 2)) * thumbHeight, maxOffset);
      track.style.transform = 'translateY(-' + offset + 'px)';
    }

    var queued = false;
    column.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          markActive();
        });
      },
      { passive: true }
    );

    markActive();
  }

  function init() {
    document.querySelectorAll('.product-information__media media-gallery').forEach(build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('load', init);
  setTimeout(init, 1200);
})();
